export const maxCustomizeNameLength = 12;
export const helpLink = 'https://support.esgisoftware.com/hc/en-us/articles/4404120217357-Account-Settings';
export const exampleImageUrl = 'https://s3.amazonaws.com/esgiwebfiles/images/test-result-verbage-example.png';
